import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Typography } from 'antd';

import {
  setClearFilters,
  updateMultipleFilters
} from 'features/filters/filtersSlice';
import { selectActiveModule } from 'features/moduleConfigs/moduleConfigsSelectors';

import { scrollToTop } from 'utils/scrollToTop';

import { MODULE_DEFAULT_SORT } from 'constants/uiSettings';

const TitleContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const activeModule = useSelector(selectActiveModule);

  const handleReset = () => {
    dispatch(setClearFilters());

    const moduleDefaults = activeModule
      ? MODULE_DEFAULT_SORT[activeModule]
      : null;

    if (moduleDefaults) {
      dispatch(
        updateMultipleFilters({
          sortField: moduleDefaults.sortField,
          order: moduleDefaults.order
        })
      );
    }

    scrollToTop();
  };

  return (
    <div className="title-container">
      <Typography className="title-text">
        {t('common.label.filters')}
      </Typography>
      <Button type="link" danger onClick={handleReset}>
        {t('common.label.resetAll')}
      </Button>
    </div>
  );
};

export default TitleContainer;
